
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import DeviceDetail from './components/DeviceDetail'
import DeviceSettings from './components/DeviceSettings'

import DeviceList from './components/DeviceList'
import FaqPage from './components/FaqPage'
import ErrorView from './components/ErrorView'

import "./assets/css/fonts.css"
import "./assets/css/bootstrap.min.css"
import "./assets/css/App.css"
import "./assets/css/font-awesome.min.css"

export default class App extends React.Component {



 render() {

  return (

    <Router>
    <div>
        <Route exact path="/" component={DeviceList} />

        <Switch>
          <Route path="/404" component={ErrorView} />
          <Route path="/faq" component={FaqPage} />
          <Route path="/:device/settings" component={DeviceSettings} />
          <Route exact path="/:device" component={DeviceDetail} />
      
        </Switch>

    </div>
    </Router>

  )
 }
}
 


// WEBPACK FOOTER //
// ./src/App.js